module.exports = __webpack_public_path__ + "static/media/certificate-mean-stack.fd8c7ca3.pdf";